import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import { inject, observer } from 'mobx-react';
import { Card, Icon, Spin, Button } from 'antd';
import AirTable from 'air-ptable';

import './FMTable.css';

@withRouter
@inject('translationsStore')
@observer
export default class FMTable extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  assetsBind = fleetManagerId => {
    this.props.assetBinding(fleetManagerId);
  };

  editFleetManager = fleetManagerId => {
    this.props.onEdit(fleetManagerId);
  };

  render() {
    const { translationsStore } = this.props;

    const columns = [
      {
        dataIndex: 'uin',
        title: translationsStore.translate('fleetManagers.table.column.uin')
      },
      {
        dataIndex: 'commonName',
        title: translationsStore.translate('fleetManagers.table.column.commonName'),
        render: (text, record) => `${record.name} ${record.surname}`
      },
      {
        dataIndex: 'companyName',
        title: translationsStore.translate('fleetManagers.table.column.companyName')
      },
      {
        dataIndex: 'email',
        title: translationsStore.translate('fleetManagers.table.column.email')
      },
      {
        dataIndex: 'pec',
        title: translationsStore.translate('fleetManagers.table.column.pec')
      },
      {
        dataIndex: 'mobile',
        title: translationsStore.translate('fleetManagers.table.column.mobile')
      },
      {
        dataIndex: 'phone',
        title: translationsStore.translate('fleetManagers.table.column.phone')
      },
      {
        dataIndex: '',
        title: '',
        render: (text, record) => (
          <Fragment>
            <Button type="primary" onClick={() => this.editFleetManager(record.id)} style={{ marginRight: 20 }}>
              <Icon type="user" style={{ fontSize: 20 }} />
            </Button>
            <Button type="primary" onClick={() => this.assetsBind(record.id)}>
              <Icon type="reconciliation" style={{ fontSize: 20 }} />
            </Button>
          </Fragment>
        )
      }
    ];

    return (
      <div className="FMTable">
        <Spin spinning={!!this.props.loading}>
          <AirTable rowKey="uin" rowSelection={false} columns={columns} dataSource={this.props.dataSource || []} pagination={{ pageSize: 10, position: 'both' }} />
        </Spin>
      </div>
    );
  }
}
